import { getEmbeddedSDK } from '@/lib/embeddedSdk.js';
import { getEmbeddedUserToken, getWorkflow } from '@/redux/actions/gravityActions';

export const handleOpenTestCredentials = async ({ installationId, integrationId, workflowId, setLoading }) => {
  setLoading?.(true);
  try {
    const sdk = await getEmbeddedSDK();

    const expiresIn = sdk.getTokenExpiration();

    if (!expiresIn || expiresIn.getTime() - Date.now() < 60 * 1000) {
      const response = await getEmbeddedUserToken();

      if (response.token) {
        sdk.setToken(response.token);
      }
    }

    // Connecting an app can create a brand-new installation (install mode) or complete an
    // existing one — either way the workflow's resolved test installationId changes on the
    // server. Refetch so step runs pick it up without a page reload.
    const onAuthenticationComplete = () => {
      if (workflowId) {
        getWorkflow({ id: workflowId, workflowVersion: 'draft' });
      }
    };

    if (installationId) {
      sdk.modify({ installationId, __isInternal: true, onAuthenticationComplete });
    } else if (integrationId) {
      sdk.install({ integrationId, __isInternal: true, onAuthenticationComplete });
    }
  } catch (error) {
    console.error('Failed to open test credentials modal:', error);
  } finally {
    setLoading?.(false);
  }
};
